import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UserDetailResponse } from '@edtech-ui/core/models/Classroom/user-detail';
import { AuthServiceService } from '@edtech-ui/core/services/authService/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
	selector: 'app-proctoring-header',
	standalone: true,
	imports: [FormsModule, MatTooltipModule, CommonModule],
	templateUrl: './proctoring-header.component.html',
	styleUrl: './proctoring-header.component.scss'
})
export class ProctoringHeaderComponent {

	@Input() isSidebarCollapsed = false;
	@Output() toggleMobileMenu = new EventEmitter<void>();
	@Output() globalSearch = new EventEmitter<string>();
	@Output() logout = new EventEmitter<void>();
	@Output() navigateToTab = new EventEmitter<string>();

	subscription = new Subscription();
	userDetail: UserDetailResponse['Data'] | null = null;
	userId = '';
	searchVal = '';
	showProfileMenu = false;



	constructor(
		private eRef: ElementRef,
		private _toastr: ToastrService,
		private _authService: AuthServiceService,
	) { }


	ngOnInit(): void {
		const storedId = localStorage.getItem('user_id');
		if (storedId) {
			this.userId = storedId;
			this.getUserInfo(this.userId);
		}
	}


	@HostListener('document:click', ['$event'])
	onDocumentClick(event: Event): void {
		if (this.showProfileMenu && !this.eRef.nativeElement.contains(event.target)) {
			this.closeProfileMenu();
		}
	}


	onSearchChange(): void {
		this.globalSearch.emit(this.searchVal);
	}


	onToggleMobileMenu(): void {
		this.toggleMobileMenu.emit();
	}


	toggleProfileMenu(event: Event): void {
		event.stopPropagation();
		this.showProfileMenu = !this.showProfileMenu;
	}


	closeProfileMenu(): void {
		this.showProfileMenu = false;
	}


	onLogout(): void {
		this.logout.emit();
	}


	selectTab(tab: string): void {
		this.navigateToTab.emit(tab);
		this.showProfileMenu = false;
	}

	getUserInfo(id: string) {
		this.subscription.add(
			this._authService.getUserDetails(id).subscribe({
				next: (response: UserDetailResponse) => {
					if (response.Success) {
						this.userDetail = response.Data;
					}
				},
				error: () => this._toastr.error('Something went wrong while fecthing the user Details')
			})
		);
	}


	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

}
